import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { coinsApi } from "@/lib/coins";
import { useAuth } from "@/context/AuthContext";

const CoinContext = createContext({ balance: 0, refresh: () => {} });
export const useCoins = () => useContext(CoinContext);

export function CoinProvider({ children }) {
    const { user } = useAuth();
    const [balance, setBalance] = useState(0);

    const refresh = useCallback(async () => {
        try { const w = await coinsApi.wallet(); setBalance(w.balance); } catch { /* ignore */ }
    }, []);

    useEffect(() => { if (user) refresh(); }, [user, refresh]);

    return <CoinContext.Provider value={{ balance, refresh }}>{children}</CoinContext.Provider>;
}
